import moment from "moment";
import { forwardRef } from "react";
import { RiCalendarTodoFill } from "react-icons/ri";
import DatePicker from "react-datepicker"

function DateInputFilter({startDate, setStartDate, endDate, setEndDate}){
   

    const onChange = (dates) => {        
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);                  
    };
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="d-flex align-items-center">
            <div>
                <button className="btn-icon mr-3" size="sm" onClick={onClick} ref={ref}><RiCalendarTodoFill className="color-888" /></button> 
            </div>
            <div>
                <span className="font-size-09rem color-333 font-weight-500">{`${moment(startDate).format("MMM, DD YYYY")} - ${moment(endDate).format("MMM, DD YYYY")}`}</span>
            </div>
        </div>
    ));
    return (
      <DatePicker
        selected={startDate}
        onChange={onChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        customInput={<ExampleCustomInput />}
        shouldCloseOnSelect={false}
        maxDate={new Date()}
      />
    );
};

export default DateInputFilter